/**
 * @generated SignedSource<<c766abeda7fe9298385ed9257f61674c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemCard_item$data = {
  readonly __typename: string;
  readonly content?: {
    readonly __typename: "File";
    readonly mimeType: string;
  } | {
    readonly __typename: "Page";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly name?: string;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementAttachmentCard_details" | "EventCard_event" | "ItemMenu_node" | "MinimalAnnouncementCard_announcement" | "SpaceCard_space" | "useItemHandleFragment">;
  readonly " $fragmentType": "ItemCard_item";
};
export type ItemCard_item$key = {
  readonly " $data"?: ItemCard_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemCard_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemCard_item",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemHandleFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemMenu_node"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventCard_event"
        }
      ],
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/)
      ],
      "type": "Folder",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                }
              ],
              "type": "File",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/)
              ],
              "type": "Page",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SpaceCard_space"
        }
      ],
      "type": "Space",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MinimalAnnouncementCard_announcement"
        }
      ],
      "type": "Announcement",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AnnouncementAttachmentCard_details"
        }
      ],
      "type": "AnnouncementAttachment",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "872bc0a5e7a089730fc40e20e5ff2dea";

export default node;
